import AnalyticsService from '@root/core/src/services/analytics-service';
import AttributionQueryParamService from '@root/attribution/src/services/attribution-query-param-service';
import { useEffect, useState } from '@root/vendor/react';

export default function useRegisterAgentAttribution() {
  const [hasRegistered, setHasRegistered] = useState(false);

  useEffect(() => {
    if (hasRegistered) { return; }

    // WindowLocationService doesn't expose .search; reading directly for URL param priority over cookie
    // eslint-disable-next-line root/prevent-use-of-window-location
    const urlParams = new URLSearchParams(window.location.search);
    const attribution = AttributionQueryParamService.read();
    const agentId = urlParams.get('agent_id') || attribution?.agent_id;
    const agencyId = urlParams.get('agency_id') || attribution?.agency_id;
    const utmSource = urlParams.get('utm_source') || attribution?.utm_source;

    if (agentId || agencyId || utmSource) {
      setHasRegistered(true);
      AnalyticsService.register({
        agent_id: agentId || null,
        agency_id: agencyId || null,
        utm_source: utmSource || null,
      });
    }
  }, [hasRegistered]);
}
